import type { AssetStatus } from "@/services/my-hardware/my-hardware.types";

export type AssetActionKind = "startReplacement" | "startReturn" | "trackOrder" | "seeReturn";

const ACTION_NEEDED_STATUSES: ReadonlySet<AssetStatus> = new Set<AssetStatus>([
  "eligibleForReplacement",
  "pendingReturn",
  "overdueReturn",
]);

export const needsAction = (status: AssetStatus): boolean => ACTION_NEEDED_STATUSES.has(status);

const ACTION_BY_STATUS: Record<AssetStatus, AssetActionKind | null> = {
  eligibleForReplacement: "startReplacement",
  pendingReturn: "startReturn",
  overdueReturn: "startReturn",
  ordered: "trackOrder",
  returnInProgress: "seeReturn",
  assigned: null,
};

export const actionForStatus = (status: AssetStatus): AssetActionKind | null =>
  ACTION_BY_STATUS[status];
